var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"download-file-template"}},[_c('b-button',{attrs:{"variant":_vm.buttonColor},on:{"click":_vm.getFile}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }